import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => ( {
	container: {
		// margin: "2rem"
	},
	image: {
		height       : "9rem",
		width        : "9rem",
		objectFit    : "cover",
		borderRadius : "1rem",
		marginRight  : "2rem"
	},
	fixedHeader: {
		top        : "70px",
		width      : "100%",
		// height: "110px",
		zIndex     : 21,
		position   : "fixed",
		background : theme.other.colors.background.secondary
	},
	header: {
		margin: "2rem"

	},
	gameContainer: {
		display    : "flex",
		alignItems : props?.hasDescription ? "flex-start" : "center"
	},
	detailsContainer: {
		flexGrow: 1
	},
	name: {
		fontSize     : "2rem",
		fontWeight   : "500",
		marginBottom : "0.5rem"
	},
	statsContainer: {
		display    : "flex",
		alignItems : "center"
	},
	ellipse: {
		width           : "4px",
		height          : "4px",
		margin          : "0rem 0.7rem",
		borderRadius    : "50%",
		backgroundColor : theme.other.colors.text.secondary
	},
	count: {
		color    : theme.other.colors.text.secondary,
		fontSize : "1.5rem"
	},
	tabsContainer: {
		width    : props?.tabsCount >= 4 ? "40%" : "35%",
		minWidth : "50rem",

		[rooterMediaQuery.mobile]: {
			width    : "100%",
			minWidth : "unset"
		}
	},
	cardListContainer: {
		margin     : "3rem 2rem",
		paddingTop : "17rem",

		[rooterMediaQuery.mobile]: {
			margin: "3rem 0"
		}
	},
	description: {
		width    : "75%",
		fontSize : "1.3rem !important",

		[rooterMediaQuery.mobile]: {
			width: "100%"
		}
	},
	descToggleBtn: {
		fontSize: "1.35rem"
	},

	spoilerRoot: {
		fontSize: "16px"
	}

} ), { name: "gamePage" } );

